import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom'

import T from '../SPRINTA/translate/T'
import Topbar from '../components/organisms/Topbar'

import AsyncComponent from '../components/atoms/AsyncComponent'

const Home = AsyncComponent(() => import("./home"))
const Homev2 = AsyncComponent(() => import("./Homev2"))
const Homev3 = AsyncComponent(() => import("./Homev3"))
const Searchv3 = AsyncComponent(() => import("./Searchv3"))
const Search = AsyncComponent(() => import("./Search"))
const Rodrigo = AsyncComponent(() => import("./Rodrigo"))
const Rewards = AsyncComponent(() => import("./Rewards"))
const Insurance = AsyncComponent(() => import("./Insurance"))
const Dev = AsyncComponent(() => import("./dev"))
const Login = AsyncComponent(() => import("./login"))
const Signup = AsyncComponent(() => import("./signup"))
const RecoverPassword = AsyncComponent(() => import("./recoverPassword"))
const Events = AsyncComponent(() => import("./event"))
const MarketPlace = AsyncComponent(() => import("./marketplace"))
const EventInscription = AsyncComponent(() => import("./eventInscription"))
const EventSubscription = AsyncComponent(() => import("./eventSubscription"))
const NotFound = AsyncComponent(() => import("./404"))
const Explore = AsyncComponent(() => import("./explore"))
const UserTimeline = AsyncComponent(() => import("./userTimeline"))
const Authorize = AsyncComponent(() => import("./authorize"))
const Article = AsyncComponent(() => import("./article"))
const GlobalPlace = AsyncComponent(() => import("./globalPlace"))
const MarketplaceProduct = AsyncComponent(() => import("./marketplaceProduct"))
const Club = AsyncComponent(() => import("./Club"))
const ClubInscription = AsyncComponent(() => import("./ClubInscription"))
const ClubLanding = AsyncComponent(() => import("./ClubLanding"))
const Experience = AsyncComponent(() => import("./Experience"))
const ExperienceLink = AsyncComponent(() => import("./ExperienceLink"))
const ExperienceSubscription = AsyncComponent(() => import("./ExperienceSubscription"))
const ObjectRate = AsyncComponent(() => import("./ObjectRate"))
const SurveySubscribed = AsyncComponent(() => import("./SurveySubscribed"))
const Challenge = AsyncComponent(() => import("./Challenge"))

class App extends Component {
  static scroll = true

  componentWillMount() {
    this.body = document.body || document.documentElement

    T.handleUpdate(() => {
      // this.scroll = false
      this.forceUpdate()
      // this.scroll = true
    })
  }

  render() {
    // if(this.scroll) {
    //   window.scrollTo(0, 0)
    //   this.body.style.overflowY = 'auto'
    // }

    return (

      <div>
        <Topbar />
        <main>
          <Switch>
            <Route exact path="/v1" component={Home} />
            <Route exact path="/v2" component={Homev2} />
            <Route exact path="/" component={Homev3} />
            <Route exact path="/search" component={Searchv3} />
            <Route exact path="/v2/search/:type?" component={Search} />
            <Route exact path="/dev" component={Dev} />
            <Route exact path="/store/:type?" component={Rodrigo} />
            <Route exact path="/rewards/:type?" component={Rewards} />
            <Route exact path="/insurance/:type?" component={Insurance} />
            <Route path="/404" component={NotFound} />            
            <Route path="/login/:type?" component={Login} />
            <Route path="/signup/:type?" component={Signup} />
            <Route path="/password/recover/:code" component={RecoverPassword} />


            <Route exact path="/survey/:subscriptionToken" component={ObjectRate} />
            <Route exact path="/survey/e/:token" component={SurveySubscribed} />
            <Route path="/(experience|x)/:token" exact component={Experience} />
            <Route path="/(linktree|x)/:token" exact component={ExperienceLink} />
            <Route path="/experience/:token/subscription" component={ExperienceSubscription} />
            
            <Route path="/(challenge|c)/:token" component={Challenge} />

            <Route exact path="/(event|experience|e)/:token" component={Events} />
            <Route exact path="/(event|experience|e)/:token/extras" component={Events} />
            <Route exact path="/(event|experience)/inscription/:token" component={EventInscription} />
            <Route exact path="/(event|experience)/subscription/:token" component={EventSubscription} />
            <Route exact path="/marketplace" component={GlobalPlace} />
            <Route exact path="/marketplace/department/:department" component={GlobalPlace} />
            <Route exact path="/marketplace/department/:department/category/:category" component={GlobalPlace} />
            <Route exact path="/marketplace/product/:id/:title?" component={MarketplaceProduct} />
            <Route exact path="/marketplace/:token/:product?" component={MarketPlace} />
            <Route exact path="/club/subscription/:token" component={ClubInscription} />
            <Route path="/club/:token/:page?/:item?" component={Club} />
            <Route exact path="/clubes/cadastre" component={ClubLanding} />


            {/* <Route exact path="/experience/inscription/:token" component={EventInscription} /> */}
            <Route exact path="/explore" component={Explore} />
            <Route exact path="/app/authorize" component={Authorize} />
            <Route exact path="/me/timeline" component={UserTimeline} />
            <Route exact path="/article/:token" component={Article} />

            <Route exact path="/panel/:token" render={ props => {
                if( props.match.params.token )
                    window.location.href = `${window.URL_DASH_HOME}${props.match.params.token}`
                return <div />
            }} />
            <Route exact path="/:username" render={ props => {
                if( props.match.params.username )
                    window.location.href = `https://sprinta.com.br/${props.match.params.username}`
                return <div />
            }} />
            <Route path="*" component={NotFound} />
            <Redirect to='/' />
          </Switch>
        </main>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/pages/App.js